var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WikiPanel',{attrs:{"border-none":true}},[_c('template',{slot:"head-title"},[_c('i',{staticClass:"el-icon-collection"}),_c('span',[_vm._v("最近攻略")])]),_c('template',{slot:"body"},[_c('el-row',{staticClass:"m-posts"},_vm._l((_vm.newestPosts),function(post,key){return _c('PostItem',{key:key,attrs:{"post":post}})}),1)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }